<ng-container *ngIf="value$ | async as value">
  <ng-content></ng-content>
  {{ value }}
  <ng-container *ngIf="!hideCurrency">&nbsp;{{ translateCurrency ? (currency | translate) : currency }}</ng-container>
</ng-container>
